var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.9 86",
    style: {
      enableBackground: "new 0 0 76.9 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#904B27;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,1.6l-2.4-1.4c-0.4-0.2-0.8-0.2-1.2-0.1c-0.4,0.1-0.8,0.4-1,0.8l-0.9,1.6c-1.8-0.2-3.5,0.7-4.4,2.3 l-2.6,4.6l-6.7,11.8v-8.6c0-2.1-1.7-3.8-3.8-3.8H5.9C5.5,8.8,5.1,9,4.8,9.3l-4.3,4.3C0.2,13.9,0,14.3,0,14.7v67.5 C0,84.3,1.7,86,3.8,86H53c2.1,0,3.8-1.7,3.8-3.8V44.4l15.7-27.6c0,0.3,0,0.5-0.1,0.7l-8.5,15c-0.4,0.8-0.2,1.7,0.6,2.2c0,0,0,0,0,0 c0.2,0.1,0.5,0.2,0.8,0.2c0.6,0,1.1-0.3,1.4-0.8l8.5-15c0.6-1,0.7-2.2,0.4-3.4c-0.2-0.8-0.7-1.6-1.3-2.1l1.9-3.3 c0.9-1.6,0.8-3.5-0.3-5l0.9-1.6C77.2,3,76.9,2,76.1,1.6z M53.6,82.2c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0H3.8c-0.3,0-0.5-0.2-0.5-0.5 c0,0,0,0,0,0V15.4L6.6,12H53c0.3,0,0.5,0.2,0.5,0.5c0,0,0,0,0,0v14.3l-9.9,17.5l-4.1,7.2v0.1l-0.1,0.2c0,0.1,0,0.1,0,0.2 c0,0,0,0,0,0.1l-2.6,12.8c0,0.1,0,0.3,0,0.4H11.8c-0.9,0.1-1.6,0.9-1.5,1.7c0.1,0.8,0.7,1.4,1.5,1.5H45c0.9,0.1,1.7-0.6,1.7-1.5 c0.1-0.9-0.6-1.7-1.5-1.7c-0.1,0-0.2,0-0.3,0h-4.2l8.5-7.6l0,0c0.1-0.1,0.2-0.2,0.3-0.4l4-7V82.2z M42.1,54.8l3.3,1.8l-4.4,4 L42.1,54.8z M53.8,43.2l-3,5.2l-3.2,5.8l-4.4-2.5l3.3-5.8l10.1-17.8l8.9-15.7l4.3,2.5L53.8,43.2z M73.3,8.8L71.5,12l-4.3-2.5 l1.8-3.2c0.4-0.6,1.1-0.9,1.8-0.6l2,1.1L72.8,7l0,0C73.4,7.4,73.6,8.2,73.3,8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,29.6H45c0.9,0.1,1.7-0.6,1.7-1.5s-0.6-1.7-1.5-1.7c-0.1,0-0.2,0-0.3,0H11.8c-0.9,0.1-1.6,0.9-1.5,1.7 C10.4,29,11,29.6,11.8,29.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,49h26.6c0.9-0.1,1.6-0.9,1.5-1.7c-0.1-0.8-0.7-1.4-1.5-1.5H11.8c-0.9,0.1-1.6,0.9-1.5,1.7 C10.4,48.3,11,48.9,11.8,49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.2399e9fdcaa61e8045d607cd0bef0be6.svg";
export { ForwardRef as ReactComponent };